import { PageResponseVm } from 'api/core/page-response.vm';
import { TeamMemberVm } from './team-member.vm';

export class GetTeamMembersVm extends PageResponseVm<TeamMemberVm, string> {
    objects: TeamMemberVm[];
    nextOffset: string | null;
}
